import React, { useState, Fragment } from "react"
import { useTranslation } from "react-i18next"

import { Button, ConfirmationModal } from "components"
import { confirmOrder } from "services"

const OrderDetailsConfirmOrderButton = props => {
  const { order, setOrders } = props

  const [t] = useTranslation()

  const [sending, setSending] = useState(false)
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)

  const handleConfirmPayment = async () => {
    setSending(true)

    try {
      await confirmOrder(order._id)

      setOrders(prev =>
        prev.map(o =>
          o._id === order._id
            ? { ...o, orderStatus: "pending" }
            : o
        )
      )
    } catch (err) {
      console.log(err)

      setSending(false)
    }
  }

  return (
    <Fragment>
      <Button
        fullWidth
        color="success"
        onClick={() => setOpenConfirmationModal(true)}
      >
        {t("تایید_سفارش")}
      </Button>

      <ConfirmationModal
        title={t("آیا_می_خواهید_این_سفارش_را_تایید_کنید")}
        show={openConfirmationModal}
        onConfirm={handleConfirmPayment}
        onHide={() => setOpenConfirmationModal(false)}
        loading={sending}
      />
    </Fragment>
  )
}

export default OrderDetailsConfirmOrderButton